var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1990_12648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 5H10C8.67392 5 7.40215 5.52678 6.46447 6.46447C5.52678 7.40215 5 8.67392 5 10V30C5 31.3261 5.52678 32.5979 6.46447 33.5355C7.40215 34.4732 8.67392 35 10 35H30C31.3261 35 32.5979 34.4732 33.5355 33.5355C34.4732 32.5979 35 31.3261 35 30V10C35 8.67392 34.4732 7.40215 33.5355 6.46447C32.5979 5.52678 31.3261 5 30 5ZM31.6667 30C31.6667 30.442 31.4911 30.866 31.1785 31.1785C30.866 31.4911 30.442 31.6667 30 31.6667H10C9.55797 31.6667 9.13405 31.4911 8.82149 31.1785C8.50893 30.866 8.33333 30.442 8.33333 30V18.3333H31.6667V30ZM8.33333 15V10C8.33333 9.55797 8.50893 9.13405 8.82149 8.82149C9.13405 8.50893 9.55797 8.33333 10 8.33333H30C30.442 8.33333 30.866 8.50893 31.1785 8.82149C31.4911 9.13405 31.6667 9.55797 31.6667 10V15H8.33333Z",
    fill: "url(#paint0_linear_1990_12648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 13.3834C14.2538 13.3834 15 12.6372 15 11.7167C15 10.7962 14.2538 10.05 13.3334 10.05C12.4129 10.05 11.6667 10.7962 11.6667 11.7167C11.6667 12.6372 12.4129 13.3834 13.3334 13.3834Z",
    fill: "url(#paint1_linear_1990_12648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.3834C20.9205 13.3834 21.6666 12.6372 21.6666 11.7167C21.6666 10.7962 20.9205 10.05 20 10.05C19.0795 10.05 18.3333 10.7962 18.3333 11.7167C18.3333 12.6372 19.0795 13.3834 20 13.3834Z",
    fill: "url(#paint2_linear_1990_12648)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1990_12648",
    x1: -12.7155,
    y1: 7.76978,
    x2: 142.677,
    y2: 117.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1990_12648",
    x1: 9.6983,
    y1: 10.3578,
    x2: 26.9641,
    y2: 22.5788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1990_12648",
    x1: 16.3649,
    y1: 10.3578,
    x2: 33.6307,
    y2: 22.5788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1990_12648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.5d2b18815654e376d031e9692db52804.svg";
export { ForwardRef as ReactComponent };